module.exports = __webpack_public_path__ + "static/img/btn.13b957f.gif";


//////////////////
// WEBPACK FOOTER
// ./src/img/btn.gif
// module id = c4I5
// module chunks = 1